// src/state/menu/types/modifierGroups_types.ts
var QuantitySizeTypes = ["light", "regular", "extra"];
var QuantityModes = /* @__PURE__ */ ((QuantityModes2) => {
  QuantityModes2["NUMBER"] = "x1,x2,x3";
  QuantityModes2["SIZE"] = "Lt,Reg,Ext";
  QuantityModes2["OFF"] = "Off";
  return QuantityModes2;
})(QuantityModes || {});
var QuantitySizes = /* @__PURE__ */ ((QuantitySizes2) => {
  QuantitySizes2["LIGHT"] = "light";
  QuantitySizes2["REGULAR"] = "regular";
  QuantitySizes2["EXTRA"] = "extra";
  return QuantitySizes2;
})(QuantitySizes || {});
var PriceCalcModes = /* @__PURE__ */ ((PriceCalcModes2) => {
  PriceCalcModes2["MAX"] = "max";
  PriceCalcModes2["MIN"] = "min";
  return PriceCalcModes2;
})(PriceCalcModes || {});

export { PriceCalcModes, QuantityModes, QuantitySizeTypes, QuantitySizes };
